import React from 'react';
import * as Sentry from '@sentry/react';
import { BrowserRouter as Router } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import FullPageError from 'components/FullPageError';
import AppContextProvider from 'context/AppContext';
import AppRoutes from 'routing/AppRoutes';

const SentryErrorBoundaryFallback = ({ error }: { error: any }) => (
  <FullPageError>
    <p>{JSON.stringify(error)}</p>
    <p>Try reloading the webpage</p>
  </FullPageError>
);

const App: React.FC = () => {
  return (
    <Sentry.ErrorBoundary fallback={SentryErrorBoundaryFallback}>
      <Router>
        <AppContextProvider>
          <AppRoutes />
        </AppContextProvider>
      </Router>
    </Sentry.ErrorBoundary>
  );
};

export default App;
